import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Button,
  OutlinedInput,
  InputLabel,
  FormControl,
  Typography,
  FormLabel,
  Tooltip,
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material';
import { ArrowBackIos, ArrowUpward } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../api/instance';
import { modules, formats } from '../../utils/TextEditor/TextEditorConfig';
import Time from '../../utils/TimeFormats';
import Loader from '../../components/Loader/Loader';

const PageEdit = () => {
  const [searchParams] = useSearchParams();
  const pageId = searchParams.get('id');
  const [page, setPage] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const formRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const mode = location.state.mode;

  useEffect(() => {
    const getProjectDetails = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/pages/${pageId}`);
        console.log('PAGE', response.data.page);
        setPage(response.data.page);
        setLoading(false);
      } catch (error) {
        setPage({});
        setLoading(false);
        console.log(error);
      }
    };

    if (mode === 'edit') {
      getProjectDetails();
    }
  }, [pageId]);

  const formSubmit = async () => {
    setSubmitting(true);
    // pageId comes from the state
    if (mode === 'edit') {
      console.log('PAGE', page);
      const response = await api.put(`/pages/${page}`, page);

      if (response.status === 200) {
        setSubmitting(false);
        // maybe I could show a message instead of redirection
        // setUpdateProjects(true); // need event to update page list
        navigate('/pages');
      } else {
        console.log('Could not update page');
        setTimeout(() => {
          setSubmitting(false);
        }, 1000);
      }
    }

    if (mode === 'create') {
      const response = await api.post('/pages', page);

      if (response.status === 201) {
        setSubmitting(false);
        // maybe I could show a message instead of redirection
        // setUpdateProjects(true); // need event to update page list
        navigate('/pages');
      } else {
        console.log('Could not create page');
        setTimeout(() => {
          setSubmitting(false);
        }, 1000);
      }
    }
  }; // CREATE/EDIT FORM SUBMIT


  const deletePage = async () => {
    console.log('ID', pageId);
    // delete pageId if on edit more and images are deleted
    if (mode === 'edit') {
      try {
        const response = await api.delete(`/pages/${pageId}`);
        if (response.status === 200) {
          console.log('page deleted');
          setPage({});
          // setUpdateProjects(true); // need event to update page list
          navigate('/pages');
        }
      } catch (error) {
        console.log('Could not delete page');
      }
    }
    // return to projects when on create mode
    if (mode === 'create') {
      console.log('Cancelled page creation');
      setPage({});
      // setUpdateProjects(true); // need event to update page list
      navigate('/pages');
    }
  }; // DELETE PROJECT

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Grid item xs={8} sx={{ marginBottom: '0.5rem' }}>
        <Link to="/pages">
          <Button color="primary">
            <ArrowBackIos /> PAGES
          </Button>
        </Link>
      </Grid>

      {loading ? (
        <Loader />
      ) : (
        <Grid item xs={12} sm={12} md={8}>
          <Typography variant="h4" className="lato" margin="normal">
            {page.title}
          </Typography>
          <Typography variant="caption">
            CREATED BY {page.createdBy ? page.createdBy.name : ''} {page.createdBy ? page.createdBy.surname : ''}
          </Typography>
          <br />
          <Typography variant="caption">LAST UPDATE {Time.dateFullFormat(page.lastUpdated)}</Typography>

          <form data-abide noValidate id="createForm" className="cell" onSubmit={(e) => formSubmit(e)} encType="multipart/form-data" ref={formRef}>
            <input type="text" className="is-hidden" name="createdBy" id="createdBy" aria-errormessage="dateCreatedErr" value="USERNAME" readOnly />

            <FormControl fullWidth margin="normal">
              <InputLabel htmlFor="name">Page Title</InputLabel>
              <OutlinedInput
                id="name"
                name="name"
                label="Project Name"
                onChange={(e) => setPage({ ...page, title: e.target.value })}
                value={page.title}
              />
            </FormControl>

            <FormControl fullWidth margin="normal">
              <FormLabel htmlFor="description">Project Description</FormLabel>
              <ReactQuill
                value={page.description}
                placeholder="Enter your page Content"
                onChange={(e) => setPage({ ...page, description: e })}
                theme="snow"
                modules={modules}
                formats={formats}
              />
            </FormControl>
          </form>

          <AppBar
            position="relative"
            className="sticky"
            data-margin-bottom="0"
            data-sticky
            data-stick-to="bottom"
            color="default"
            style={{ top: 'auto', bottom: 0, borderRadius: '0.2rem', background: '#fff', margin: '1rem 0' }}
          >
            <Toolbar>
              <div style={{ flex: 2 }}>
                <Tooltip title="Top" placement="top">
                  <IconButton fontSize="small" onClick={scrollTop} style={{ marginLeft: -12, marginRight: 20 }} color="primary" aria-label="Menu">
                    <ArrowUpward />
                  </IconButton>
                </Tooltip>
              </div>
              <div className="right" style={{ gap: '1rem', display: 'flex' }}>
                <Button fontSize="small" onClick={() => deletePage()} style={{ flex: 1 }} color="error" aria-label="Menu">
                  {mode === 'edit' ? 'DELETE' : 'CANCEL'}
                </Button>
                <Button fontSize="small" onClick={() => formSubmit()} style={{ flex: 1 }} color="primary" aria-label="Menu">
                  {submitting ? 'Saving' : 'Save'}
                </Button>
              </div>
            </Toolbar>
          </AppBar>
        </Grid>
      )}
    </>
  );
};

export default PageEdit;
